// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthForm_root__3xt2S","textField":"AuthForm_textField__2CTRr","controls":"AuthForm_controls__Hw6qv","form":"AuthForm_form__1qA5d","inputWrap":"AuthForm_inputWrap__1kCci"};